<template>
  <div class="supplier-container">
    <div class="t-top-bar">
      <el-input placeholder="编号、自编号、名称" v-model="listQuery.keyword" class="input-with-select search-input">
        <el-button  slot="append"  type="primary" icon="el-icon-search" @click="getList">搜索</el-button>
      </el-input>
      <div class="btns">
        <a title="导入模板下载" href="/supplierImport.xlsx" download="供应商导入模板">导入模板下载</a>
        <el-upload style="margin-left: 15px" v-if="authedCheck('导入供应商')" title="导入产品"
                   class="upload-demo" :data="uploadParam"
                   :action="uploadUrl" :show-file-list="false"
                   :multiple="false" :on-success="uploadHandler" :on-progress="uploadProgressHandler">
          <el-button type="primary">导入</el-button>
        </el-upload>
        <el-button style="margin-left: 15px" type="primary" v-if="authedCheck('供应商信息同步')" title="供应商信息同步" @click="dispatchHandler">同步</el-button>
        <el-button type="primary" v-if="authedCheck('添加供应商')" title="添加供应商" @click="addHandler">添加</el-button>
      </div>
    </div>
    <el-table :data="tableData" border style="width: 100%" v-loading="listLoading">
      <el-table-column prop="supplierId" label="编号" width="100"></el-table-column>
      <el-table-column prop="supplierSerial" label="自编号"></el-table-column>
      <el-table-column prop="supplierName" label="供应商名称"></el-table-column>
      <el-table-column prop="concator" label="联系人"></el-table-column>
      <el-table-column prop="phone" label="联系方式"></el-table-column>
      <el-table-column prop="startBalance" label="期初余额"></el-table-column>
      <el-table-column label="操作" width="150">
        <template slot-scope="scope">
          <el-tooltip content="编辑信息" placement="top">
            <i class="el-icon-edit el-icon-table btn-primary" v-if="authedCheck('编辑供应商信息')" @click="editHandler(scope.row)"></i>
          </el-tooltip>
          <el-tooltip content="删除供应商信息" placement="top">
            <i class="el-icon-delete el-icon-table btn-danger" v-if="authedCheck('删除供应商信息')" @click="deleteHandler(scope.row)"></i>
          </el-tooltip>
          <el-tooltip content="价格分配" placement="top">
            <i class="el-icon-share el-icon-table btn-primary" v-if="authedCheck('价格分配')" @click="priceHandler(scope.row)"></i>
          </el-tooltip>
          <el-tooltip content="设置期初余额" placement="top">
            <div  @click="startBalanceHandler(scope.row)" style="display: inline-block">
              <svg-icon  v-if="authedCheck('设置期初余额')" class="svg-icon-money" icon-class="money"  width="24px" height="24px"></svg-icon>
            </div>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <pagination :total="total" :page.sync="listQuery.page" :limit.sync="listQuery.size" @pagination="getList" />


    <el-dialog :title="opFlag=='add'?'添加供应商信息':'编辑供应商信息'" @close="addCloseHandler" :visible.sync="addDialogVisiable" width="650px">
      <el-form :model="addForm" :rules="rules" ref="addForm">
        <el-form-item label="供应商名称" prop="supplierName" :label-width="formLabelWidth">
          <el-input v-model="addForm.supplierName" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="自编号" prop="supplierSerial" :label-width="formLabelWidth">
          <el-input v-model="addForm.supplierSerial" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="联系人" prop="concator"  :label-width="formLabelWidth">
          <el-input v-model="addForm.concator" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="联系方式" prop="phone"  :label-width="formLabelWidth">
          <el-input v-model="addForm.phone" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="addDialogVisiable = false">取 消</el-button>
        <el-button type="primary" @click="addConfirm">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="设置期初余额" :visible.sync="balanceDialogVisiable" width="450px">
      <el-input type="number" v-model="startBalance"></el-input>
      <div slot="footer" class="dialog-footer">
        <el-button @click="balanceDialogVisiable = false">取 消</el-button>
        <el-button type="primary" @click="balanceConfirm">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="计价规则分配" :visible.sync="priceDialogVisiable" width="1150px">
      <div style="margin-bottom: 15px">
        <el-input placeholder="请输入内容" v-model="priceListQuery.keyword" class="input-with-select search-input">
          <el-button  slot="append"  type="primary" icon="el-icon-search" @click="getPriceList0">搜索</el-button>
        </el-input>
      </div>
      <el-table ref="priceTable" max-height="500px" :data="priceData" border style="width: 100%;" v-loading="priceListLoading"
                @selection-change="priceSelectionChange" @filter-change="filterChangeHandler">
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column prop="priceId" label="规则编号" width="100"></el-table-column>
        <el-table-column prop="priceName" label="规则名称"></el-table-column>
        <el-table-column prop="price" label="单价(元)"></el-table-column>
        <el-table-column prop="append" label="备注"></el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button @click="priceDialogVisiable = false">取 消</el-button>
        <el-button type="primary" @click="priceOk">确 定</el-button>
      </div>
    </el-dialog>
    <DispatchDialog ref="dispatchDialog" :dispatchType="7"></DispatchDialog>
  </div>
</template>

<script>
    import Pagination from '@/components/Pagination';
    import { addSupplier,updateSupplier,getSupplierPageList, deleteSupplier,updateSupplierStartBalance } from '../../api/supplier'
    import localCache from "@/util/localCache";
    import DispatchDialog from '../../components/DispatchDialog/DispatchDialog'
    import {getPriceList,addSupplierPriceRelation,getSupplierCurrentPrice} from "@/api/supplierPrice";
export default {
name: "supplier",
    components: {
        Pagination,
        DispatchDialog
    },
  data() {
    return {
      addDialogVisiable: false,
      balanceDialogVisiable: false,
      priceDialogVisiable: false,
      priceListLoading: false,
      opFlag: 'add',
      formLabelWidth: '120px',
      tableData: [],
      priceData:[],
      addForm: {
        supplierName: '',
        supplierSerial: '',
        concator: '',
        phone: ''
      },
        rules: {
          supplierName: [
                { required: true, message: '名不能为空', trigger: 'blur' },
                { min: 1, max: 15, message: '长度在 1 到 64 个字符', trigger: 'blur' }
            ],
          supplierSerial: [
                { min: 3, max: 8, message: '长度在 3 到 100 个字符', trigger: 'blur' }
            ],
            concator: [
                { min: 2, max: 15, message: '长度在 2 到 15 个字符', trigger: 'blur' }
            ],
          phone: [
                { min: 3, max: 25, message: '长度在 3 到 25 个字符', trigger: 'blur' }
            ],
        },
        listQuery: {
            page: 1,
            size: 10,
            keyword: ''
        },
      priceListQuery: {
        page: 1,
        size: 10,
        keyword: '',
        useType:1
      },
        total: 0,
        listLoading: true,
      selectRow: '',
      startBalance: 0,
      uploadLoading: '',
      uploadUrl: process.env.VUE_APP_BASE_API+'/fileupload',
      uploadParam:{
        type: 4,
      },
      priceSelected: []
    }
  },
    mounted(){
      this.uploadParam.customerId = localCache.getCurrentCustomerId()
      this.uploadParam.token = localCache.getToken()
      this.getList()
    },
  methods: {
    balanceConfirm(){
      updateSupplierStartBalance({
        customerId: localCache.getCurrentCustomerId(),
        supplierId: this.selectRow.supplierId,
        balance: parseFloat(this.startBalance).toFixed(2)
      }).then((res)=>{
        if(res.errorcode == 0){
          this.$message.success('设置成功')
          this.balanceDialogVisiable = false
          this.selectRow.startBalance = this.startBalance
        }else{
          this.$message.error(res.message)
        }
      })
    },
    dispatchHandler(){
      this.$refs.dispatchDialog.open()
    },
      addCloseHandler(){
          this.$refs['addForm'].resetFields()
          this.addForm =  {
              company: '',
              address: '',
              concator: '',
              concatorPhone: ''
          }
      },
    addHandler() {
      this.opFlag='add'
      this.addDialogVisiable = true
    },
    startBalanceHandler(row){
      this.startBalance = row.startBalance
      this.selectRow = row
      this.balanceDialogVisiable = true
    },
    editHandler(row) {
      this.selectRow = row
      this.opFlag='edit'
      this.addForm = Object.assign({}, row)
      this.addDialogVisiable = true
    },
      addConfirm() {
          this.$refs['addForm'].validate((valid) => {
              if (!valid) {
                  return
              }
              let param = Object.assign({}, this.addForm)
              if(this.opFlag == 'add'){
              }else if(this.opFlag == 'edit'){
                  param.supplierId = this.selectRow.supplierId
              }
              param.customerId = localCache.getCurrentCustomerId()
              if(this.opFlag=='add'){
                addSupplier(param).then((res)=>{
                      if(res.errorcode==0){
                          this.$message.success('添加成功')
                          this.addDialogVisiable = false
                          this.getList()
                      }else{
                          this.$message.error(res.message)
                      }
                  })
              }else{
                updateSupplier(param).then((res)=>{
                      if(res.errorcode==0){
                          this.$message.success('修改成功')
                          this.addDialogVisiable = false
                          this.getList()
                      }else{
                        this.$message.error(res.message)
                      }
                  })
              }
          });
      },
      getList() {
          this.listLoading = true
        this.listQuery.customerId = localCache.getCurrentCustomerId()
          getSupplierPageList(this.listQuery).then(res => {
              this.listLoading = false
              if (res.errorcode !== 0) {
                  this.$message.error(res.message)
              } else {
                  this.tableData = res.data.content
                  this.total = res.data.total
              }
          }).catch(() => {
              this.listLoading = false
          })
      },
    deleteHandler(row){
      this.$msgbox.confirm('确认删除？')
          .then(_ => {
            deleteSupplier({
              supplierId: row.supplierId,
              customerId: localCache.getCurrentCustomerId()
            }).then((res)=>{
              if(res.errorcode==0){
                this.$message.success('删除成功')
                this.getList()
              }else{
                this.$message.error(res.message)
              }
            })
          }).catch(_ => {});
    },
    uploadHandler(res, file, fileList){
      if (res.errorcode !== 0) {
        this.$message.error(res.message)
      } else {
        this.$message.success('导入成功')
        this.getList()
      }
      this.uploadLoading.close()
    },
    uploadProgressHandler(event, file, fileList){
      this.uploadLoading = this.$loading({
        lock: true,
        text: '导入中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
    },
    priceHandler(row){
      this.priceDialogVisiable = true
      this.selectRow = row
      this.getPriceList0()
    },
    priceSelectionChange(val){
      console.log(val)
      this.priceSelected = val
    },
    getPriceList0() {
      this.priceListLoading = true
      this.priceListQuery.customerId = localCache.getCurrentCustomerId()
      getPriceList(this.priceListQuery).then(res => {
        this.priceListLoading = false
        if (res.errorcode !== 0) {
          this.$message.error(res.message)
        } else {
          this.priceData = res.data
          this.getSupplierCurrentPrice0()
        }
      }).catch(() => {
        this.priceListLoading = false
      })
    },
    priceOk(){
      addSupplierPriceRelation({
        customerId: localCache.getCurrentCustomerId(),
        supplierId: this.selectRow.supplierId,
        priceIds: this.priceSelected.map(t=>t.priceId).join(",")
      }).then(res => {
        if (res.errorcode !== 0) {
          this.$message.error(res.message)
        } else {
          this.$message.success('分配成功')
          this.priceDialogVisiable = false
        }
      }).catch((e) => {
        this.$message.error(e)
      })
    },
    getSupplierCurrentPrice0(){
      getSupplierCurrentPrice({
        customerId: localCache.getCurrentCustomerId(),
        supplierId: this.selectRow.supplierId
      }).then(res => {
        if (res.errorcode !== 0) {
          this.$message.error(res.message)
        } else {
          let data = res.data
          if(data && data.length > 0){
            let arr = data.map(t=>t.priceId)
            this.priceData.forEach(t=>{
              if(arr.indexOf(t.priceId)>-1){
                this.$refs.priceTable.toggleRowSelection(t, true)
              }
            })
          }
        }
      }).catch((e) => {
        this.$message.error(e)
      })
    },
    filterChangeHandler(filters){
      console.log(filters)
    }
  }
}
</script>

<style lang="scss">
.supplier-container{
  .t-top-bar{
    margin-bottom: 15px;
    .btns{
      float: right;
      display: flex;
      align-items: center;
      width: 350px;
      justify-content: flex-end;
    }
  }
  .search-input {
    width: 350px;
  }
  .l-add-buttion{
    font-size: 35px;
    float: right;
    cursor: pointer;
  }
  .svg-icon-money{
    color: #eb9f14;
    width: 20px;
    height: 21px;
    cursor: pointer;
  }
}
</style>
